// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xCommonActions } from "@keller/App/Store/Reducers/xCommon";
import { isMobileScreen, isSmallMobileScreen, isTabletScreen, isWideScreen } from "@keller/XDL/Utilities";
import { FC, useEffect } from "react";
import { connect, DispatchProp } from "react-redux";

type Props = DispatchProp<xCommonActions>;

const XngUtilities: FC<Props> = ({ dispatch }) => {
    // const handleScroll = () => {}

    const handleResize = () => {
        const isSmallMobile = isSmallMobileScreen();
        const isMobile = isMobileScreen();
        const isTablet = isTabletScreen();
        const isLargeScreen = isWideScreen();

        dispatch({ type: "xCommon/update", data: { key: "isSmallMobileScreen", value: isSmallMobile } });
        dispatch({ type: "xCommon/update", data: { key: "isMobileScreen", value: isMobile } });
        dispatch({ type: "xCommon/update", data: { key: "isTabletScreen", value: isTablet } });
        dispatch({ type: "xCommon/update", data: { key: "isWideScreen", value: isLargeScreen } });
    };

    useEffect(() => {
        // document.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleResize, { passive: true });
        handleResize();
        return () => {
            // document.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    });

    return null;
};

export default connect(null)(XngUtilities);
